import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo/benchmarklogo.png";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
      }}
    >
      {/* <img src={Logo} alt="logo" style={{ height: 72, marginBottom: 24 }} /> */}
      <Result
        status="404"
        title={
          <span style={{ fontSize: 72, fontWeight: 800, color: "#00215E", lineHeight: 1 }}>
            404
          </span>
        }
        subTitle={
          <span style={{ fontSize: 16, color: "#666" }}>
            ขออภัย ไม่พบหน้าที่คุณต้องการ
          </span>
        }
        extra={
          <Button
            // type="primary"
            size="large"
            style={{ backgroundColor: "#00215E", borderColor: "#00215E", borderRadius: 8 , color:"#ffffff" }}
            onClick={() => navigate("/")}
          >
            กลับไปหน้าหลัก
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
